import { CSSProperties } from 'react';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { getShouldUseAttestaion } from '~/growthbook';
import CheckCircleBlue from '~/images/check-circle-blue.svg';
import { IUserConsent } from '~/models';

interface IProps {
  consent?: IUserConsent;
  style?: CSSProperties;
}

export const ProfessionalAttestationInfo = ({ consent, style }: IProps) => {
  if (!getShouldUseAttestaion() || !consent?.is_consented) {
    return <></>;
  }

  return (
    <Column justify="center" align="center" style={style}>
      {consent?.consented_requirements?.map((item) => (
        <Row
          key={item.key}
          align="center"
          justify="center"
          px={4}
          py={1}
          gap={1}
          style={{ backgroundColor: colors.primary[50], borderRadius: 8 }}
        >
          <img src={CheckCircleBlue} style={{ height: 24, width: 24 }} alt="" />
          <Typography as="span" bold>
            {item.value} Complete
          </Typography>
        </Row>
      ))}
    </Column>
  );
};
